import { useState } from "react";
import "./contact.scss";

export default function Contact() {
    const [message, setMessage] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage(true);
    };

    return (
        <div className="contact" id="contact">
            <div className="left">
                <img src="assets/shake.svg" alt="" />
            </div>
            <div className="right">
                <h2>Contact.</h2>
                <form onSubmit={handleSubmit} >
                    <input type="text" placeholder="Email" />
                    <textarea placeholder="Message"></textarea>
                    <button type="submit" onClick={(e) => {
                        e.preventDefault();
                        window.open("mailto:rishiagrawal0405@gmail.com");
                    }}>Send</button>
                    {message && <span>Thanks, I'll reply ASAP :)</span>}
                </form>
                <div className="images">
                    <img src="assets/linkedin.png" onClick={(e) => {
                        e.preventDefault();
                        window.location.href = 'https://www.linkedin.com/in/rishi-agrawal0405/';
                    }}
                        alt="" />
                    <img src="assets/github.png" style={{ width: "70px" }} onClick={(e) => {
                        e.preventDefault();
                        window.location.href = 'https://github.com/RISHIAGRAWAL0405';
                    }}
                        alt="" />
                    <img src="assets/facebook.png" style={{ width: "50px" }} onClick={(e) => {
                        e.preventDefault();
                        window.location.href = 'https://www.facebook.com/rishi.agarawal.568';
                    }}
                        alt="" />

                </div>
            </div>
        </div>
    );
}

